<script setup lang="ts">
import { type SUREbusinessManagementKvkKvkBedrijfDto as KvkBedrijfDto } from '@services/overig/orval-api/model/sUREbusinessManagementKvkKvkBedrijfDto';

const props = defineProps<{ option: KvkBedrijfDto }>();
</script>

<template>
  <div class="flex flex-row gap-2 font-bold">
    <span>{{ props.option.kvkNummer }}</span>
    <div class="flex flex-col gap-2">
      <span>{{ props.option.naam }}</span>
      <span class="text-sm font-normal text-grey-400">
        {{ props.option.straat }}, {{ props.option.plaats }}
      </span>
    </div>
  </div>
</template>
